import { getTimeAgo } from '@captaincause/lib/getTimeAgo'
import { Html } from '../Html'
import { tm } from '../tm'
import { YoutubeIframe } from '../YoutubeIframe'
import type { Locales, ProjectUpdate } from '@captaincause/types'

interface DialogAllNewsProps {
  news: ProjectUpdate
  locale: Locales
}

export function ProjectNewsCardDialog({ news, locale }: DialogAllNewsProps) {
  return (
    <div className="flex flex-col overflow-y-auto px-2 md:px-4 md:py-2">
      <div className="mb-4 flex items-center gap-2">
        <div className="flex h-10 min-h-[40px] w-10 min-w-[40px] items-center justify-center overflow-hidden rounded-full border border-light-purple bg-white p-[1px]">
          <img
            src={news.project.organization.logo}
            alt={`${news.project.organization.name} logo`}
            className="h-full w-full rounded-full object-contain"
          />
        </div>

        <div className="flex flex-col text-start">
          <span className="text-sm font-medium leading-6">
            {news.project.organization.name}
          </span>
          <time
            className="text-[10px] leading-[8px] text-dark-gray lg:text-sm lg:leading-5 [&::first-letter]:capitalize"
            dateTime={news.created_at}
          >
            {getTimeAgo({
              dateString: news.created_at,
              locale,
            })}
          </time>
        </div>
      </div>

      {news.image || news.youtube_id ? (
        <div className={tm('mb-4 h-60', news.image_legend && 'mb-6')}>
          {news.image && !news.youtube_id ? (
            <img
              src={news.image}
              alt={`${news.name} update`}
              width={400}
              height={224}
              className={tm(
                'h-full w-full rounded-md object-cover',
                news.image_legend && 'mb-1',
              )}
              loading="lazy"
            />
          ) : null}
          {news.youtube_id ? (
            <YoutubeIframe className="m-0 !w-full" id={news.youtube_id} />
          ) : null}
          {news.image_legend ? (
            <span className="mx-auto line-clamp-3 hidden px-6 text-center text-xs text-gray md:block md:max-w-[400px] md:px-4">
              {news.image_legend}
            </span>
          ) : null}
        </div>
      ) : null}

      <div className="flex flex-col">
        <div className={tm('flex flex-col gap-4 rounded-lg md:gap-4')}>
          <div className="flex flex-[2] flex-col items-start">
            <div className="mb-2 text-left text-xl font-medium">
              {news.name}
            </div>
            {news.body ? (
              <Html className="text-left text-dark-gray">
                {news.body.replaceAll('<br><br>', '<br>')}
              </Html>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
